import { useDialog } from '@/ui-plus/dialog/use-dialog';
import NameValidationForm from '@iframe-widgets/pages/widgets/dialogs/name-validation/NameValidationForm.vue';
import { toast } from '@/ui-plus/sonner';

const dialog = useDialog();

export function showNameForm() {
    return new Promise((resolve) => {
        dialog.show({
            title: 'Your name is required',
            closeable: false,
            // description: 'Please enter your name. This is a one-time process and will not be required in the future.',
            component: NameValidationForm,
            onSuccess: () => {
                resolve(1);
            },
            onError: (message: string) => {
                console.error(message);
                toast.error(message);
                resolve(-1);
            },
            onCancel: () => {
                resolve(-1);
            }
        })
    })
}
